export default "__VITE_ASSET__DZx52vgw__"